import { render, staticRenderFns } from "./ColumnAdjusterCard.vue?vue&type=template&id=4ecb2127&"
import script from "./ColumnAdjusterCard.vue?vue&type=script&lang=js&"
export * from "./ColumnAdjusterCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports